import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    addressLine1: {
      label: {
        id: 'properties.addressLine1',
        defaultMessage: 'Address line 1',
        description: 'label of the form field name',
      },
    },
    addressLine2: {
      label: {
        id: 'properties.addressLine2',
        defaultMessage: 'Address line 2',
        description: 'label of the form field vat number',
      },
    },
    postalCode: {
      label: {
        id: 'properties.postalCode',
        defaultMessage: 'Postal code',
        description: 'label of the form field billing email address',
      },
    },
    city: {
      label: {
        id: 'properties.city',
        defaultMessage: 'City',
        description: 'label of the form field city',
      },
    },
    country: {
      label: {
        id: 'properties.country',
        defaultMessage: 'Country',
        description: 'label of the form field country',
      },
    },
  },
  formActions: {
    cancel: {
      id: 'formActions.cancel',
      defaultMessage: 'Cancel',
      description: 'label of the form action cancel button',
    },
    save: {
      id: 'formActions.save',
      defaultMessage: 'Save',
      description: 'label of the form action save button',
    },
  },
};

export default defineMessages(translations);
